import React from 'react';
import { Icons4 } from './Icons4';
import './WhatWeDo.css';

const cards = [
  {
    icon: Icons4.LearnerReadiness,
    name: "Know who's ready - and who isn't.",
    quote:
      'Real time dashboards show completion, progress, and skill development - for every learner, every team, all the way to the CEO.',
  },
  {
    icon: Icons4.FasterOnboarding,
    name: 'Get the person up to speed, faster.',
    quote:
      'Personalised learning paths mean every new hire and team member gets exactly what they need - not a one-size-fits-all course list.',
  },
  {
    icon: Icons4.BusinessOutcomeTracking,
    name: 'Connect every training hour to a real business outcome.',
    quote:
      'Track the link between learning and on-the-job performance - and give leadership the numbers that matter.',
  },
];

export default function WhatWeDo() {
  return (
    <section className="what-we-do">
      <div className="what-we-do__container">
        <div className="what-we-do__eyebrow">What Magnetix does</div>
        <h2 className="what-we-do__heading">
          Not just what they completed - what they can now do.
        </h2>

        <div className="what-we-do__grid">
          {cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <div key={index} className="what-we-do__card">
                <div className="what-we-do__chip">
                  <Icon className="what-we-do__chip-icon" />
                </div>
                <div className="what-we-do__name">{card.name}</div>
                <div className="what-we-do__quote">{card.quote}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
